import React from 'react';

function How() {
    return(
        <div>How to</div>
    )
}

export default How;